<div class="modal-container">
  <div class="modal" (clickOutside)="closeModalWindow()">
    <div class="close-button" (click)="closeModalWindow()"></div>
    <ng-content></ng-content>
  </div>
</div>
